import { BloodTestUpdateData, BloodTestRestAndExerciseData } from "./types";

/**
 * Converts separate rest and exercise API responses into combined blood test form values format
 */
export const convertBloodTestApiResponsesToFormValues = (
    restResponse: BloodTestUpdateData,
    exerciseResponse: BloodTestUpdateData
): BloodTestRestAndExerciseData => {
    return Object.keys(restResponse).reduce((acc, key) => {
        const _key = key as keyof BloodTestUpdateData;
        acc[_key] = {
            rest: restResponse[_key],
            exercise: exerciseResponse[_key],
        };
        return acc;
    }, {} as BloodTestRestAndExerciseData);
};

/**
 * Converts combined blood test form values into separate rest and exercise objects
 */
export const convertBloodTestFormValuesToSeparateObjects = (
    formValues: BloodTestRestAndExerciseData
): { restData: BloodTestUpdateData; exerciseData: BloodTestUpdateData } => {
    const restData: BloodTestUpdateData = {} as BloodTestUpdateData;
    const exerciseData: BloodTestUpdateData = {} as BloodTestUpdateData;

    Object.keys(formValues).forEach((key) => {
        const fieldKey = key as keyof BloodTestRestAndExerciseData;
        const fieldData = formValues[fieldKey];
        restData[fieldKey] = fieldData.rest;
        exerciseData[fieldKey] = fieldData.exercise;
    });

    return { restData, exerciseData };
};